import { FC, useMemo } from 'react'
import { Dialog } from '@ui/overlays/dialog/dialog';

import { DialogBody } from '@ui/overlays/dialog/dialog-body';
import { clsx } from 'clsx';

import { useSearchParams } from 'react-router';
import { useDialogContext } from '@ui/overlays/dialog/dialog-context';

export const SortByEnum = {
    NAME_ASC: 'name:asc',
    NAME_DESC: 'name:desc',
    RELEASE_DATE_ASC: 'release_date:asc',
    RELEASE_DATE_DESC: 'created_at:desc',
    POPULARITY_ASC: 'popularity:asc',
    POPULARITY_DESC: 'popularity:desc',
}
export const sorts = [
    // {
    //     key: 'Name A-Z',
    //     value: SortByEnum.NAME_ASC
    // },
    // {
    //     key: 'Name Z-A',
    //     value: SortByEnum.NAME_DESC
    // },
    {
        key: 'Latest',
        value: SortByEnum.RELEASE_DATE_DESC
    },
    // {
    //     key: 'Oldest first',
    //     value: SortByEnum.RELEASE_DATE_DESC
    // },
    {
        key: 'Popular',
        value: SortByEnum.POPULARITY_DESC
    },
    // {
    //     key: 'Popularity Z-A',
    //     value: SortByEnum.POPULARITY_DESC
    // }
]

export const SortBy: FC = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const sort = useMemo(() => searchParams.get('order') || 'createdAt', [searchParams])

    const { close } = useDialogContext()

    return (
        <Dialog className="!max-h-224 md:!max-w-224 !mt-auto !mb-auto">
            <DialogBody padding="p-10">
                {sorts.map((item) => (
                    <button
                        key={item.value}
                        className={clsx(
                            'flex mb-2 last-of-type:mb-0 items-center gap-10 px-10 py-5 w-full',
                            sort === item.value ? 'bg-primary/10' : 'text-muted hover:text-primary hover:bg-hover'
                        )}
                        onClick={() => {
                            searchParams.set('order', item.value)
                            setSearchParams(searchParams)

                            close()
                        }}
                    >
                        {item.key}
                    </button>
                ))}
            </DialogBody>
        </Dialog>
    )
}
